import { render, staticRenderFns } from "./AddChannel.vue?vue&type=template&id=93565bac&scoped=true"
import script from "./AddChannel.vue?vue&type=script&lang=js"
export * from "./AddChannel.vue?vue&type=script&lang=js"
import style0 from "./AddChannel.vue?vue&type=style&index=0&id=93565bac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93565bac",
  null
  
)

export default component.exports